module.exports = __webpack_public_path__ + "img/yay.f00726d9.png";